import Loadable from 'react-loadable'
import LoadingBlock from "../LoadingBlock";

export default Loadable({
    loader: () =>
        import('./Notification'),
    loading: LoadingBlock
})
